export enum RiskLevel {
  Low,
  Increasing,
  High
}
export type RiskIndexer<T> = {
  [id in RiskLevel]: T;
};
